// 等服务器模块加载完就去设置
export default function aplusConfig() {
  // 获取公共打点参数
  function getModuleProps(ele) {
    return '';
    // ToDo, 未来差异化投放时用来获取策略版本号
    // if (!ele || ele.tagName.toUpperCase() === 'BODY') {
    //   return '';
    // }
    // const moduleName = ele.getAttribute('data-modulename');
    // const moduleVersion = ele.getAttribute('data-moduleversion');
    // if (moduleName) {
    //   return `modulename=${moduleName}&moduleversion=${moduleVersion}`;
    // }
    // return getModuleProps(ele.parentElement);
  }

  const q = (window.goldlog_queue || (window.goldlog_queue = []));
  q.push({
    action: 'goldlog.setMetaInfo',
    arguments: ['aplus-auto-exp-watchdom', 'throttle'],
  });
  q.push({
    action: 'goldlog.setMetaInfo',
    arguments: ['aplus-auto-exp', [
     
      {
        logkey: '/sc.sales.intelligent.product_exp',
        cssSelector: '[data-logtype=product]',
        props: ['data-params'],
        
      }, {
        logkey: '/sc.sales.intelligent.supplier_exp',
        cssSelector: '[data-logtype=supplier]',
        props: ['data-params'],
        
      }, {
        logkey: '/sc.sales.intelligent.entrance_exp',
        cssSelector: '[data-logtype=entrance]',
        props: ['data-params'],
        
      }, {
        logkey: '/sc.sales.intelligent.nav_exp',
        cssSelector: '[data-logtype=nav]',
        props: ['data-params'],
      }, {
        logkey: '/sc.sales.intelligent.custom_exp',
        cssSelector: '[data-logtype=custom]',
        props: ['data-params'],
        
      },
      {
        logkey: '/sc.sales.entrance_exp',
        tag: 'a',
        cssSelector: '[data-logtype=otherlink]',
        props: ['data-params'],
        
      },
      {
        logkey: '/sc.sales.product-recommend',
        tag: 'a',
        cssSelector: '[data-aplus-auto-filter=true]',
        props: ['data-params'],
        
      }
    ]],
  });
  q.push({
    action: 'goldlog.setMetaInfo',
    arguments: ['aplus-auto-clk', [
      {
        logkey: '/sc.sales.product-recommend',
        tag: 'a',
        cssSelector: '[data-aplus-auto-filter=true]',
        props: ['data-params'],
        
      },
      {
        logkey: '/sc.sales.entrance_clk',
        tag: 'a',
        cssSelector: '[data-logtype=otherlink]',
        props: ['data-params'],
        
      },
      {
        logkey: '/sc.sales.intelligent.product_clk',
        cssSelector: '[data-logtype=product]',
        props: ['data-params'],
        
      }, {
        logkey: '/sc.sales.intelligent.supplier_clk',
        cssSelector: '[data-logtype=supplier]',
        props: ['data-params'],
        
      }, {
        logkey: '/sc.sales.intelligent.entrance_clk',
        cssSelector: '[data-logtype=entrance]',
        props: ['data-params'],
        
      }, {
        logkey: '/sc.sales.intelligent.nav_clk',
        cssSelector: '[data-logtype=nav]',
        props: ['data-params'],
        
      }, {
        logkey: '/sc.sales.intelligent.custom_clk',
        cssSelector: '[data-logtype=custom]',
        props: ['data-params'],
        
      }
    ]],
  });

  q.push({
    action: 'goldlog.setMetaInfo',
    arguments: ['aplus-auto-exp-userfn', function (element) {
      return getModuleProps(element);
    }],
  });
  q.push({
    action: 'goldlog.setMetaInfo',
    arguments: ['aplus-auto-clk-userfn', function (element) {
      return getModuleProps(element);
    }],
  });
}